import { render, staticRenderFns } from "./InteresOrdinario.vue?vue&type=template&id=71e4c6aa&"
import script from "./InteresOrdinario.vue?vue&type=script&lang=js&"
export * from "./InteresOrdinario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports